module.exports = __webpack_public_path__ + "media/tips/00_tas_de_vetement-d7b7f16b.png";